module.exports = __webpack_public_path__ + "static/media/close.a2a5d236.svg";